// import React from "react";

// // reactstrap components
// import "components/custom.css";
// import API from "api.js";
// // import NotificationAlert from "react-notification-alert";
// import RightCard from "components/Payments/RightSideCard";
// import { Elements } from "@stripe/react-stripe-js";
// import { loadStripe } from "@stripe/stripe-js";
// import StripeElements from "components/Payments/StripeElements";
// import ErrorPopup from "components/PopUps/ErrorPopup";
// import SelectPaymentMethod from "components/Plans/SelectPaymentMethod";
// import PaymentCard from "components/Payments/PaymentCard";
// import errImage from "../assets/images/1-05.png";
// import ReactHtmlParser from 'react-html-parser';
// import SidebarClose from "components/Sidebar/SidebarClose";
// import { Button } from "reactstrap";

// let stripe;

// let publishableKey;
// if (import.meta.env.VITE_ENV === "production") {
//   publishableKey = import.meta.env.VITE_STRIPE_LIVE_APP_KEY || "pk_test_placeholder";
// } else {
//   publishableKey = import.meta.env.VITE_STRIPE_TEST_APP_KEY || "pk_test_placeholder";
// }
// const stripePromise = publishableKey !== "pk_test_placeholder" ? loadStripe(publishableKey) : null;
// class Subscription extends React.Component {
//   state = {
//     cvc: "",
//     message: "",
//     expYear: "",
//     expMonth: "",
//     cardNumber: "",
//     formProcess: false,
//     paymentStatus: false,
//     plan: false,
//     country: null,
//     discount: false,
//     prorationSubtotal: null,
//     paymentError: {
//       hasError: false,
//       error: "",
//     },
//     paymentMethod: "CARD"
//   };

//   componentDidMount() {
//     // Check if this is a redirect from Stripe checkout
//     const query = new URLSearchParams(window.location.search);
//     if (query.get("success") || query.get("canceled")) {
//       // Don't load plan if it's a redirect, just show the payment status
//       return;
//     }
    
//     this.loadPlan();
//     document
//       .getElementsByTagName("body")[0]
//       .classList.add("leftSidebarClosed", "package-payment-page");
//   }

//   componentWillUnmount() {
//     document
//       .getElementsByTagName("body")[0]
//       .classList.remove("leftSidebarClosed", "package-payment-page");
//   }

//   /**
//    * Load Selected Plan.
//    */
//   loadPlan = () => {
//     const base_url = import.meta.env.VITE_URL_ALT + "/api/v2/";
//     API({
//       method: "GET",
//       url: base_url + "plan-wl/" + this.props.match.params.id,
//     })
//       .then((data) => {
//         const { data: plan, prorationSubtotal } = data.data;
//         const discount = prorationSubtotal !== null;
//         if (plan.new !== "YES") {
//           // this.props.history.replace("/admin/dashboard");
//           // return;
//         }
//         this.setState(
//           { plan, country: data.data.country, discount, prorationSubtotal },
//           () => {
//             this.loadStripe();
//           }
//         );
//       })
//       .catch(() => {});
//   };

//   handleChange = (evt) => {
//     this.setState({
//       [evt.target.name]: evt.target.value,
//     });
//   };

//   notify = (type, message) => {
//     switch (type) {
//       case 1:
//         type = "success";
//         break;
//       case 2:
//         type = "danger";
//         break;
//       default:
//         break;
//     }
//     var options = {};
//     options = {
//       place: "tr",
//       message: (
//         <div>
//           <div>{message}</div>
//         </div>
//       ),
//       type: type,
//       icon: "now-ui-icons ui-1_bell-53",
//       autoDismiss: 7,
//     };
//     // this.refs.notificationAlert.notificationAlert(options);
//   };

//   /**
//    * Api call to purchase.
//    */
//   purchase = async (data) => {
//     let bodyFormData = new FormData();
//     bodyFormData.set("plan", this.props.match.params.id);
//     bodyFormData.set("country", this.state.country);
//     // bodyFormData.set("token", data.stripe_token);
//     bodyFormData.set("token", data);

//     if (
//       this.state.discount &&
//       this.state.prorationSubtotal &&
//       this.state.prorationSubtotal.subtotal
//     ) {
//       bodyFormData.set("proration_time", this.state.prorationSubtotal.time);
//       bodyFormData.set("proration_subtotal", this.state.prorationSubtotal.subtotal);
//     }

//     // API call
//     let res = null;
//     const url = import.meta.env.VITE_URL_ALT + "/api/v2/subscribe-wl";
//     try {
//       res = await API({
//         method: "POST",
//         url: url,
//         data: bodyFormData,
//       });
//     } catch (error) {
//       console.log(error);
//     }

//     // process if we get response from server.
//     if (res) {
//       // if success.
//       if (res.status === 200) {
//         if (res.data.actionRequired) {
//           const { paymentIntent, error } = await stripe.confirmCardPayment(
//             res.data.data.clientSecret
//           );

//           if (error) {
//             this.setState({
//               paymentError: { hasError: true, error: error.message },
//             });
//             // alert(error.message);
//             if(res.data.data.update_invoice) {
//               try {
//                 res = await API({
//                   method: "POST",
//                   url: "voidInvoice",
//                   data: {"invoiceId": res.data.data.update_invoice},
//                 });
//               } catch (error) {
//                 console.log(error);
//               }
//             }
//           } else if (paymentIntent.status === "succeeded") {
//             this.notify(1, res.data.message);
//             this.setState({ paymentStatus: true });
//           }
//           // const res2 = await axios.get(`http://localhost:5000/check/${res.data.id}`);
//           // alert(`Payment successful, payment ID - ${res.data.id}`);
//         } else {
//           if(res.data && res.data.data && res.data.data.status && res.data.data.status === "requires_payment_method") {
//             this.notify(1, "Payment failed, please contact your card issuer, or use another payment method.");
//             this.setState({
//               formProcess: false,
//             });
//             return;
//           }
//           this.notify(1, res.data.message);
//           this.setState({ paymentStatus: true });
//         }
//       }

//       // if failed.
//       if (!res.status) {
//         this.notify(1, "Something went wrong");
//       }

//       // set State message.
//       this.setState({
//         message: ``,
//         formProcess: false,
//       });
//     }
//   };

//   pay = async (e) => {
//     e.preventDefault();
//     if (
//       !this.state.cardNumber ||
//       !this.state.expMonth ||
//       !this.state.expYear ||
//       !this.state.cvv
//     ) {
//       this.setState({ message: "All fields are required" });
//       return;
//     }
//     this.setState({
//       formProcess: true,
//       message: "",
//     });

//     // Create token and send token to api.
//     window.stripeV2.createToken(
//       {
//         number: this.state.cardNumber,
//         exp_month: this.state.expMonth,
//         exp_year: this.state.expYear,
//         cvc: this.state.cvc,
//       },
//       async (status, response) => {
//         if (status === 200) {
//           this.purchase({ stripe_token: response.id });
//         } else {
//           this.setState({
//             message: response.error.message,
//             formProcess: false,
//           });
//         }
//       }
//     );
//   };

//   loadStripe = () => {
//     const { country } = this.state;
//     let key;

//     if (import.meta.env.VITE_ENV === "production") {
//       key = import.meta.env.VITE_STRIPE_LIVE_APP_KEY;
//     } else {
//       key = import.meta.env.VITE_STRIPE_TEST_APP_KEY
//     }

//     if (!window.document.getElementById("stripe-script")) {
//       var s = window.document.createElement("script");
//       s.id = "stripe-script";
//       s.type = "text/javascript";
//       s.src = "https://js.stripe.com/v3/";
//       s.onload = () => {
//         stripe = window.Stripe(key);
//       };
//       window.document.body.appendChild(s);
//     }

//   };


//   /**
//    * initiate UPI payment.
//    */
//   upiSelected = () => {
//     this.props.history.push(`/admin/ccav/plans`);
//   }


//   /**
//    * render stripe payment form.
//    */
//   stripeForm = () => {
//     return (
//       <div className="panel panel-default">
//         {/*<h2 className="paymentFormTitle">Payments</h2>*/}
//         <Elements
//           children={
//             <StripeElements
//               stripe={stripePromise}
//               purchase={this.purchase}
//               message={this.state.message}
//               formProcess={this.state.formProcess}
//               planIsValid={this.state.plan.price === 0 ? false : true}
//               setFormProcess={(status) =>
//                 this.setState({ formProcess: status })
//               }
//             />
//           }
//           stripe={stripePromise}
//         />
//         <p className="mt-2"></p>
//       </div>
//     );
//   }

//   selectedMethod = (method) => {
//     this.setState({ paymentMethod: method });
//   }

//   makePayment = () => {
//     const data = {
//       id: this.props.match.params.id,
//       success_url: `${window.location.origin}/admin/payment/status?success=true`,
//       cancel_url: `${window.location.origin}/admin/payment/status?canceled=true`
//     };

//     API({
//       url: "createCheckoutSession",
//       method: "POST",
//       data
//     })
//       .then((response) => {
//         console.log(response);
//         if(response.status === 200) {
//           window.location.href = response.data.checkout_url;
//         } else {
//           console.log('Payment failed');
//         }
//       })
//       .catch((error) => {
//         console.error('Error creating checkout session:', error);
//       });
//   }

//   // OLD ASYNC/AWAIT VERSION - COMMENTED OUT
//   // makePayment = async () => {
//   //   const data = {
//   //     id: this.props.match.params.id,
//   //     success_url: `${window.location.origin}/admin/payment/status?success=true`,
//   //     cancel_url: `${window.location.origin}/admin/payment/status?canceled=true`
//   //   }

//   //   let response = await API({
//   //     url: "createCheckoutSession",
//   //     method: "POST",
//   //     data
//   //   });

//   //   console.log(response);
//   //   if(response.status !== 200) {
//   //     console.log('failed');
//   //     return;
//   //   }

//   //   window.location.href = response.data.checkout_url;
//   // }

//   render() {
//     // Check if this is a redirect from Stripe checkout
//     console.log("thids.props",this.props);
    
//     const query = new URLSearchParams(window.location.search);
//     if (query.get("success") || query.get("canceled")) {
//       return <PaymentCard />;
//     }

//     if (this.state.paymentStatus) {
//       // this.props.history.push(`/admin/sub/success?p=${this.state.plan.price}&currency=${ReactHtmlParser(this.state.plan.currency)}`);
//     }

//     return (
//       <>
//         <div className="content content-payment">
//           {/* <SidebarClose /> */}
//           <div className="">
//             {this.state.paymentError.hasError && (
//               <ErrorPopup
//                 country={this.state.country}
//                 upi={this.upiSelected}
//                 toggle={() => {
//                   this.setState({
//                     paymentError: { hasError: false, error: "" },
//                   });
//                 }}
//                 message="Payment failed"
//                 subMessage={this.state.paymentError.error}
//                 img={<img src={errImage} style={{ width: "50%" }} alt="Error" />}
//               />
//             )}
//             {/* <NotificationAlert ref="notificationAlert" /> */}
//             <div className="row paymentFormOuter">
//               <div className="col-xs-12 col-md-7 mr-auto pt-5 subPaymentPage paymentFormBlk">
//                 {this.state.country !== null && this.state.country !== "IN" && this.state.plan !== false ? (
//                   <div className="panel panel-default">
//                     <h2 className="paymentFormTitle">Payments</h2>
//                     {/* OLD STRIPE ELEMENTS FORM - COMMENTED OUT
//                     <Elements
//                       children={
//                         <StripeElements
//                           stripe={stripePromise}
//                           purchase={this.purchase}
//                           message={this.state.message}
//                           formProcess={this.state.formProcess}
//                           planIsValid={this.state.plan.price === 0 ? false : true}
//                           setFormProcess={(status) =>
//                             this.setState({ formProcess: status })
//                           }
//                         />
//                       }
//                       stripe={stripePromise}
//                     />
//                     */}
//                     {/* NEW STRIPE HOSTED CHECKOUT */}
//                     <Button className="btn btn-primary btn-lg" onClick={this.makePayment}>
//                       Proceed to Checkout
//                     </Button>
//                     <p className="mt-2">You will be redirected to Stripe's secure checkout page</p>
//                   </div>
//                 ) : (
//                   <SelectPaymentMethod
//                     stripeForm={this.stripeForm}
//                     country={this.state.country}
//                     isGold={this.state.plan.is_gold}
//                     selectedMethod={this.selectedMethod}
//                     plan={this.state.plan}
//                     makePayment={this.makePayment}
//                   />
//                 )}
//               </div>
//               {this.state.plan && (
//                 <RightCard
//                   plan={this.state.plan}
//                   discount={this.state.discount}
//                   prorationSubtotal={this.state.prorationSubtotal}
//                   paymentMethod={this.state.paymentMethod}
//                 />
//               )}
//             </div>
//           </div>
//         </div>
//       </>
//     );
//   }
// }

// export default Subscription;


import React, { useState, useEffect } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";

// reactstrap components
// import "components/custom.css";
import API from "api.js";
// import NotificationAlert from "react-notification-alert";
import RightCard from "components/Payments/RightSideCard";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import StripeElements from "components/Payments/StripeElements";
import ErrorPopup from "components/PopUps/ErrorPopup";
import SelectPaymentMethod from "components/Plans/SelectPaymentMethod";
import PaymentCard from "components/Payments/PaymentCard";
import errImage from "../assets/images/1-05.png";
import ReactHtmlParser from 'react-html-parser';
import SidebarClose from "components/Sidebar/SidebarClose";
import { Button } from "reactstrap";

let stripe;

let publishableKey;
if (import.meta.env.VITE_ENV === "production") {
  publishableKey = import.meta.env.VITE_STRIPE_LIVE_APP_KEY || "pk_test_placeholder";
} else {
  publishableKey = import.meta.env.VITE_STRIPE_TEST_APP_KEY || "pk_test_placeholder";
}
const stripePromise = publishableKey !== "pk_test_placeholder" ? loadStripe(publishableKey) : null;

const Subscription = () => {
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();

  const [state, setState] = useState({
    cvc: "",
    message: "",
    expYear: "",
    expMonth: "",
    cardNumber: "",
    formProcess: false,
    paymentStatus: false,
    plan: false,
    country: null,
    discount: false,
    prorationSubtotal: null,
    paymentError: {
      hasError: false,
      error: "",
    },
    paymentMethod: "CARD"
  });

  useEffect(() => {
    // Check if this is a redirect from Stripe checkout
    const query = new URLSearchParams(window.location.search);
    if (query.get("success") || query.get("canceled")) {
      // Don't load plan if it's a redirect, just show the payment status
      return;
    }
    
    loadPlan();
    document
      .getElementsByTagName("body")[0]
      .classList.add("leftSidebarClosed", "package-payment-page");

    return () => {
      document
        .getElementsByTagName("body")[0]
        .classList.remove("leftSidebarClosed", "package-payment-page");
    };
  }, []);

  /**
   * Load Selected Plan.
   */
  const loadPlan = () => {
    const base_url = import.meta.env.VITE_URL_ALT + "/api/v2/";
    API({
      method: "GET",
      url: base_url + "plan-wl/" + params.id,
    })
      .then((data) => {
        const { data: plan, prorationSubtotal } = data.data;
        const discount = prorationSubtotal !== null;
        if (plan.new !== "YES") {
          // history.replace("/admin/dashboard");
          // return;
        }
        setState(prevState => ({
          ...prevState,
          plan,
          country: data.data.country,
          discount,
          prorationSubtotal
        }));
        loadStripe();
      })
      .catch(() => {});
  };

  const handleChange = (evt) => {
    setState(prevState => ({
      ...prevState,
      [evt.target.name]: evt.target.value,
    }));
  };

  const notify = (type, message) => {
    switch (type) {
      case 1:
        type = "success";
        break;
      case 2:
        type = "danger";
        break;
      default:
        break;
    }
    var options = {};
    options = {
      place: "tr",
      message: (
        <div>
          <div>{message}</div>
        </div>
      ),
      type: type,
      icon: "now-ui-icons ui-1_bell-53",
      autoDismiss: 7,
    };
    // this.refs.notificationAlert.notificationAlert(options);
  };

  /**
   * Api call to purchase.
   */
  const purchase = async (data) => {
    let bodyFormData = new FormData();
    bodyFormData.set("plan", params.id);
    bodyFormData.set("country", state.country);
    // bodyFormData.set("token", data.stripe_token);
    bodyFormData.set("token", data);

    if (
      state.discount &&
      state.prorationSubtotal &&
      state.prorationSubtotal.subtotal
    ) {
      bodyFormData.set("proration_time", state.prorationSubtotal.time);
      bodyFormData.set("proration_subtotal", state.prorationSubtotal.subtotal);
    }

    // API call
    let res = null;
    const url = import.meta.env.VITE_URL_ALT + "/api/v2/subscribe-wl";
    try {
      res = await API({
        method: "POST",
        url: url,
        data: bodyFormData,
      });
    } catch (error) {
      console.log(error);
    }

    // process if we get response from server.
    if (res) {
      // if success.
      if (res.status === 200) {
        if (res.data.actionRequired) {
          const { paymentIntent, error } = await stripe.confirmCardPayment(
            res.data.data.clientSecret
          );

          if (error) {
            setState(prevState => ({
              ...prevState,
              paymentError: { hasError: true, error: error.message },
            }));
            // alert(error.message);
            if(res.data.data.update_invoice) {
              try {
                res = await API({
                  method: "POST",
                  url: "voidInvoice",
                  data: {"invoiceId": res.data.data.update_invoice},
                });
              } catch (error) {
                console.log(error);
              }
            }
          } else if (paymentIntent.status === "succeeded") {
            notify(1, res.data.message);
            setState(prevState => ({ ...prevState, paymentStatus: true }));
          }
          // const res2 = await axios.get(`http://localhost:5000/check/${res.data.id}`);
          // alert(`Payment successful, payment ID - ${res.data.id}`);
        } else {
          if(res.data && res.data.data && res.data.data.status && res.data.data.status === "requires_payment_method") {
            notify(1, "Payment failed, please contact your card issuer, or use another payment method.");
            setState(prevState => ({
              ...prevState,
              formProcess: false,
            }));
            return;
          }
          notify(1, res.data.message);
          setState(prevState => ({ ...prevState, paymentStatus: true }));
        }
      }

      // if failed.
      if (!res.status) {
        notify(1, "Something went wrong");
      }

      // set State message.
      setState(prevState => ({
        ...prevState,
        message: ``,
        formProcess: false,
      }));
    }
  };

  const pay = async (e) => {
    e.preventDefault();
    if (
      !state.cardNumber ||
      !state.expMonth ||
      !state.expYear ||
      !state.cvv
    ) {
      setState(prevState => ({ ...prevState, message: "All fields are required" }));
      return;
    }
    setState(prevState => ({
      ...prevState,
      formProcess: true,
      message: "",
    }));

    // Create token and send token to api.
    window.stripeV2.createToken(
      {
        number: state.cardNumber,
        exp_month: state.expMonth,
        exp_year: state.expYear,
        cvc: state.cvc,
      },
      async (status, response) => {
        if (status === 200) {
          purchase({ stripe_token: response.id });
        } else {
          setState(prevState => ({
            ...prevState,
            message: response.error.message,
            formProcess: false,
          }));
        }
      }
    );
  };

  const loadStripe = () => {
    const { country } = state;
    let key;

    if (import.meta.env.VITE_ENV === "production") {
      key = import.meta.env.VITE_STRIPE_LIVE_APP_KEY;
    } else {
      key = import.meta.env.VITE_STRIPE_TEST_APP_KEY
    }

    if (!window.document.getElementById("stripe-script")) {
      var s = window.document.createElement("script");
      s.id = "stripe-script";
      s.type = "text/javascript";
      s.src = "https://js.stripe.com/v3/";
      s.onload = () => {
        stripe = window.Stripe(key);
      };
      window.document.body.appendChild(s);
    }

  };


  /**
   * initiate UPI payment.
   */
  const upiSelected = () => {
    navigate(`/admin/ccav/plans`);
  }


  /**
   * render stripe payment form.
   */
  const stripeForm = () => {
    return (
      <div className="panel panel-default">
        {/*<h2 className="paymentFormTitle">Payments</h2>*/}
        <Elements
          children={
            <StripeElements
              stripe={stripePromise}
              purchase={purchase}
              message={state.message}
              formProcess={state.formProcess}
              planIsValid={state.plan.price === 0 ? false : true}
              setFormProcess={(status) =>
                setState(prevState => ({ ...prevState, formProcess: status }))
              }
            />
          }
          stripe={stripePromise}
        />
        <p className="mt-2"></p>
      </div>
    );
  }

  const selectedMethod = (method) => {
    setState(prevState => ({ ...prevState, paymentMethod: method }));
  }

  const makePayment = () => {
    console.log("inside make payment");
    
    const data = {
      id: params.id,
      success_url: `${window.location.origin}/admin/payment/status?success=true`,
      cancel_url: `${window.location.origin}/admin/payment/status?canceled=true`
    };

    API({
      url: "createCheckoutSession",
      method: "POST",
      data:{
        id:params.id,
        platform:"la_pte"
      }
    })
      .then((response) => {
        console.log("la_pte",response);
        if(response.status === 200) {
          window.location.href = response.data.checkout_url;
        } else {
          console.log('Payment failed');
        }
      })
      .catch((error) => {
        console.error('Error creating checkout session:', error);
      });
  }

  // OLD ASYNC/AWAIT VERSION - COMMENTED OUT
  // const makePayment = async () => {
  //   const data = {
  //     id: params.id,
  //     success_url: `${window.location.origin}/admin/payment/status?success=true`,
  //     cancel_url: `${window.location.origin}/admin/payment/status?canceled=true`
  //   }

  //   let response = await API({
  //     url: "createCheckoutSession",
  //     method: "POST",
  //     data
  //   });

  //   console.log(response);
  //   if(response.status !== 200) {
  //     console.log('failed');
  //     return;
  //   }

  //   window.location.href = response.data.checkout_url;
  // }

  // Check if this is a redirect from Stripe checkout
  console.log("props", { navigate, params, location });
  
  const query = new URLSearchParams(window.location.search);
  if (query.get("success") || query.get("canceled")) {
    return <PaymentCard />;
  }

  if (state.paymentStatus) {
    // navigate(`/admin/sub/success?p=${state.plan.price}&currency=${ReactHtmlParser(state.plan.currency)}`);
  }

  return (
    <>
      <div className="content content-payment">
        {/* <SidebarClose /> */}
        <div className="">
          {state.paymentError.hasError && (
            <ErrorPopup
              country={state.country}
              upi={upiSelected}
              toggle={() => {
                setState(prevState => ({
                  ...prevState,
                  paymentError: { hasError: false, error: "" },
                }));
              }}
              message="Payment failed"
              subMessage={state.paymentError.error}
              img={<img src={errImage} style={{ width: "50%" }} alt="Error" />}
            />
          )}
          {/* <NotificationAlert ref="notificationAlert" /> */}
          <div className="row paymentFormOuter">
            <div className="col-xs-12 col-md-7 mr-auto pt-5 subPaymentPage paymentFormBlk">
              {state.country !== null && state.country !== "IN" && state.plan !== false ? (
                <div className="panel panel-default">
                  <h2 className="paymentFormTitle">Payments</h2>
                  {/* OLD STRIPE ELEMENTS FORM - COMMENTED OUT
                  <Elements
                    children={
                      <StripeElements
                        stripe={stripePromise}
                        purchase={purchase}
                        message={state.message}
                        formProcess={state.formProcess}
                        planIsValid={state.plan.price === 0 ? false : true}
                        setFormProcess={(status) =>
                          setState(prevState => ({ ...prevState, formProcess: status }))
                        }
                      />
                    }
                    stripe={stripePromise}
                  />
                  */}
                  {/* NEW STRIPE HOSTED CHECKOUT */}
                  <Button className="btn btn-primary btn-lg" onClick={makePayment}>
                    Proceed to Checkout
                  </Button>
                  <p className="mt-2">You will be redirected to Stripe's secure checkout page</p>
                </div>
              ) : (
                <SelectPaymentMethod
                  stripeForm={stripeForm}
                  country={state.country}
                  isGold={state.plan.is_gold}
                  selectedMethod={selectedMethod}
                  plan={state.plan}
                  makePayment={makePayment}
                />
              )}
            </div>
            {state.plan && (
              <RightCard
                plan={state.plan}
                discount={state.discount}
                prorationSubtotal={state.prorationSubtotal}
                paymentMethod={state.paymentMethod}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Subscription;